const PHI_FIELD_NAMES_RAW = [
    'firstName',
    'lastName',
    'middleName',
    'fullName',
    'dob',
    'dateOfBirth',
    'birthDate',
    'ssn',
    'socialSecurityNumber',
    'phone',
    'phoneNumber',
    'mobile',
    'cell',
    'fax',
    'email',
    'emailAddress',
    'address',
    'street',
    'addressLine1',
    'addressLine2',
    'city',
    'state',
    'zip',
    'zipCode',
    'mrn',
    'medicalRecordNumber',
    'diagnosis',
    'diagnoses',
    'icd10',
    'noteText',
    'sessionNote',
    'progressNote',
    'treatmentPlan',
    'transcript',
    'transcription',
    'behaviorData',
    'assessmentResult',
    'medication',
    'medications',
    'prescription',
    'insuranceMemberId',
    'subscriberId',
    'policyNumber',
];

export const PHI_FIELD_NAMES: ReadonlySet<string> = new Set(PHI_FIELD_NAMES_RAW.map((s) => s.toLowerCase()));

export const PHI_PATTERNS: ReadonlyArray<RegExp> = [
    /\b\d{3}-\d{2}-\d{4}\b/g,
    /\b\d{3}[-.\s]?\d{3}[-.\s]?\d{4}\b/g,
    /\b[\w.+-]+@[\w.-]+\.\w{2,}\b/g,
    /ISODate\(['"]\d{4}-\d{2}-\d{2}[^'"]*['"]\)/g,
];

export const REDACTED = '[REDACTED]';

export function isPhiFieldName(key: string): boolean {
    return PHI_FIELD_NAMES.has(key.toLowerCase());
}

export function scrubPhiPatterns(value: string): string {
    if (!value) return value;
    let result = value;
    for (const pattern of PHI_PATTERNS) {
        result = result.replace(pattern, REDACTED);
    }
    return result;
}

export function stripQueryString(url: string | undefined): string | undefined {
    if (!url) return url;
    const i = url.indexOf('?');
    return i >= 0 ? url.slice(0, i) : url;
}
